/* eslint-disable import/prefer-default-export */
export function decodeQueryChar(urlData: string) {
  return urlData.replace(/%40/g, '@');
}

export function queryToURL(values: { [key: string]: string | number }) {
  const keys = Object.keys(values);
  const searchParams = new URLSearchParams();
  keys.forEach((key) => values[key] && searchParams.append(key, values[key].toString()));
  return decodeQueryChar(searchParams.toString());
}
